

export const MealOfferingCalculation = ({ CustomerMealPackage, KitchenMealOffering }) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (CustomerMealPackage) {
        case 'one person':
            return (KitchenMealOffering * 1);
        case 'two person':
            return (KitchenMealOffering * 2);
        case 'four person':
            return (KitchenMealOffering * 4);
        default:
            return (KitchenMealOffering)
    }

}